import { Info } from "@mui/icons-material";
import React from "react";

const NoDocumentAvailable = (props) => {
    return <div className="icon-text">
        <Info style={{ color: "var(--hti-magenta)" }} />
        <p style={{ marginLeft: "10px" }}>No Document Available</p>
    </div>
}

export default NoDocumentAvailable;